import React from "react";
import { createBrowserRouter } from "react-router-dom";

import { AuthenticationPage } from "Pages/Authentication/Authentication.page";
import { CognitoCallbackPage } from "Pages/Authentication/CognitoCallback.page";
import { App } from "Pages/App/App";
import { AuthorizedApp } from "Pages/AuthorizedApp/AuthorizedApp";
import { SessionGate } from "Pages/AuthorizedApp/SessionGate";

import { AuthorizedRouter } from "./AuthorizedRouter";
// import RemoteControl from "Pages/RemoteControl";
// import CynemaComponent from "Pages/RemoteControl/components/CynemaComponent";

export const router = createBrowserRouter([
  {
    path: "",
    element: <App />,
    children: [
      {
        path: "",
        element: (
          <SessionGate>
            <AuthorizedApp />
          </SessionGate>
        ),
        children: AuthorizedRouter,
      },
      // {
      //   path: "/rc",
      //   element: <RemoteControl />,
      // },
      // {
      //   path: "/cynema",
      //   element: <CynemaComponent fullScreen={true} />,
      // },
      {
        path: "/login",
        element: <AuthenticationPage />,
      },
      {
        path: "/login/callback",
        element: <CognitoCallbackPage />,
      },
    ],
  },
]);
